<!--
  ModeTab — animated header tab with sliding underline indicator.
  When `active`, an animated gradient underline glows beneath the label.
-->
<script lang="ts">
  interface Props {
    active?: boolean;
    disabled?: boolean;
    onclick?: () => void;
    children?: import('svelte').Snippet;
  }
  let { active = false, disabled = false, onclick, children }: Props = $props();
</script>

<button
  type="button"
  class="mode-tab"
  class:active
  class:disabled
  {disabled}
  onclick={() => { if (!disabled) onclick?.(); }}
>
  <span class="lbl">
    {#if children}{@render children()}{/if}
  </span>
  <span class="underline" aria-hidden="true"></span>
</button>

<style>
  .mode-tab {
    position: relative;
    display: inline-flex; align-items: center;
    padding: 8px 14px;
    border: 0; background: transparent;
    color: var(--text-3, #9eb8d6);
    font-family: inherit; font-size: 12.5px; font-weight: 500;
    letter-spacing: 0.01em;
    cursor: pointer;
    border-radius: 8px;
    transition: color 0.15s ease, background 0.15s ease;
  }
  .mode-tab:hover:not(.disabled):not(.active) { color: var(--text-bright, #fff); background: rgba(255,255,255,0.04); }
  .mode-tab.active { color: var(--text-bright, #fff); }
  .mode-tab.disabled { opacity: 0.35; cursor: not-allowed; }

  .underline {
    position: absolute;
    left: 14px; right: 14px; bottom: 2px;
    height: 2px; border-radius: 2px;
    background: linear-gradient(90deg, transparent, #4ab8ff 30%, #1a7ac9 50%, #4ab8ff 70%, transparent);
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.2s ease;
    opacity: 0;
    box-shadow: 0 0 8px rgba(74, 184, 255, 0.55);
  }
  .mode-tab.active .underline { transform: scaleX(1); opacity: 1; }

  .lbl { display: inline-flex; align-items: center; gap: 6px; }
</style>
